import Lara from "@/presets/lara";

export const priceOverrideBulkUpdateModalPresets = {
  ...Lara,
  message: {
    ...Lara.message,
    root: (args) => ({
      class: [
        "rounded-md",
        "border-solid border-[1px] border-l-[6px]",

        "bg-red-300/20",
        "border-red-500/40",
        "text-error",
        "my-1",
      ],
    }),
    wrapper: {
      class: [
        // Flexbox
        "flex items-center",

        // Spacing
        "py-2 px-2",
      ],
    },
  },
};
